import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { MobilityView } from '@/module/Author/Mobility/MobilityView';
import { getMobilityOptions } from '@/module/Author/Mobility/model/MobilityQuery';

export const Route = createFileRoute('/_auth/author/_author/mobility/_mobility/$mobilityId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { mobilityId } = Route.useParams();
  const { data: mobility } = useSuspenseQuery(getMobilityOptions(mobilityId));

  return <MobilityView mobility={mobility} />;
}
